export default function getFileNameFromUrl(url) {
  if (!url) return;
  const filename = url
    .split('/Videos/')
    .pop()
    .split('?')[0];
  return decodeURI(filename);
}
